export class ApiError extends Error {
  constructor(message, code, response) {
    super(message)
    this.name = 'ApiError'
    this.code = code
    this.response = response
    this.isOperational = true
  }
}

export class ValidationError extends Error {
  constructor(message, fields) {
    super(message)
    this.name = 'ValidationError'
    this.fields = fields
    this.isOperational = true
  }
}

export class AuthenticationError extends Error {
  constructor(message) {
    super(message)
    this.name = 'AuthenticationError'
    this.isOperational = true
  }
}
